import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { CompanyInsightsService } from 'src/app/_services/company-insights.service';
import { PersonSearchService,Similarobject } from 'src/app/_services/person-search.service';
import * as _ from 'underscore';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { AiModalScComponent, SCPassData } from 'src/app/ai-modal-sc/ai-modal-sc.component';
import { from } from 'rxjs';
import { SimilarCandidateService } from 'src/app/_services/similar-candidate.service';

@Component({
  selector: 'app-similar-candidates',
  templateUrl: './similar-candidates.component.html',
  styleUrls: ['./similar-candidates.component.scss']
})
export class SimilarCandidatesComponent implements OnInit {
  @ViewChild('uploadlinkedin') uploadlinkedin: TemplateRef<any>;
  @ViewChild('uploadResume') uploadResume: TemplateRef<any>;

  
  linkedinurl: string = ''
  uploadedFilename: any
  similarobj: Similarobject;
  linkedinerrormsg: string = ''
  parseresumeresp: any
  disableSimilarBtn: boolean = true;
  constructor(private modalService: NgbModal, private personsearchservice: PersonSearchService, private router: Router, private companyinsightsservice: CompanyInsightsService,  private localStorageService: LocalStorageService,
    private similarCandidateService: SimilarCandidateService) { }

  ngOnInit() {
  }

  uploadonLinkedin() {
    const confirmRef = this.modalService.open(this.uploadlinkedin, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });

  }

  getdetailsFromLinkedin() {
    this.linkedinerrormsg = '';
    if(!this.linkedinurl) return;
    this.personsearchservice.getdetailsfromlinkedin(this.linkedinurl).subscribe((res:any)=>{
      if(res.status == "success") {
        if(res.data) {
          const pastindustries = _.pluck(res.data.experience, 'company')
          const schools = _.pluck(res.data.education, 'school')
          const locations = []
          res.data.location_locality && locations.push(res.data.location_locality);
          res.data.location_region && locations.push(res.data.location_region);
          res.data.location_country && locations.push(res.data.location_country);

          const totalTenure = res.data.totaltenure || 0;  
          const fromYrsOfExperience = (parseInt(totalTenure) - (parseInt(totalTenure) * 0.25));
          const toYrsOfExperinece = (parseInt(totalTenure) + (parseInt(totalTenure) * 0.25));
        
          this.similarobj = {
            jobtitle: res.data.job_title ? [{ key: res.data.job_title, isMandatory: true }] : [],
            jobcompanyname: res.data.job_company_name ? [{ key: res.data.job_company_name, isMandatory: false }] : [],
            jobindustryname: res.data.job_company_industry ? [{ key: res.data.job_company_industry, isMandatory: true }] : [],
            pastindustries: _.pluck(pastindustries, 'industry'),
            schools: schools && schools.length ? _.pluck(schools, 'name').map(el => ({key: el, isMandatory: false}) ) : [],
            currentlocation: _.uniq(locations).map(l => ({ key: l, isMandatory: false })),
            skills: res.data.skills ? res.data.skills.map(s => ({ key: s, isMandatory: false })) : [],
            elasticid: res.data.id,
            companysize: res.data.job_company_size ? [{ key: res.data.job_company_size, isMandatory: false }] : [],
            fullname: res.data.full_name,
            linkedinurl: this.linkedinurl,
            isUploadedFromResume: false,
            locationregion: res.data.location_region,
            locationcontinent: res.data.location_continent,
            totaltenure: totalTenure,
            fromYrsOfExperience,
            toYrsOfExperinece
  
          }   
          
          if(res.data.location_continent != 'europe' && res.data.location_continent != 'antarctica' && res.data.location_country != 'philippines') {
            this.openSimilarCandidateFilters('similar-candidate-from-linkedinurl');
          } else {
            this.linkedinerrormsg = `Apologies, profiles from the "${res.data.location_continent}" region are not displayed due to GDPR constraints.`
          }
        } else if(res.message == 'Person not found') {
          this.linkedinerrormsg = 'Sorry, for some reason we were unable to find this LinkedIn profile.'
        }
 
    
      }
    })

  }

  getobj(): Similarobject {
    return this.similarobj;
  }

  dismiss() {
    this.uploadedFilename = null;
    this.disableSimilarBtn = true;
    this.linkedinurl = '';
    
    this.modalService.dismissAll()
  }

  uploadFromResume() {
    const confirmRef = this.modalService.open(this.uploadResume, { size: 'xs' as 'lg', centered: true, backdrop: 'static', keyboard: false });

  }

  uploadFile(event) {
    let file = event.target.files[0]
    this.uploadedFilename = file.name
    this.personsearchservice.parseresume(file).subscribe((res:any)=>{
      if(res.status == "success") {
        this.parseresumeresp = res.message
        const locations = [];
        res.message.address[0].City && locations.push(res.message.address[0].City)
        res.message.address[0].State && locations.push(res.message.address[0].State)
        res.message.address[0].Country && locations.push(res.message.address[0].Country)
        let skills = res.message.skills.filter(x=>x.type != 'SoftSkill')
        const employer = _.pluck(res.message.segregateedexperience, 'Employer')
        const pastindustries = _.pluck(employer, 'EmployerName')
        const recommendpayload ={
          startindex: 0,
          resultsize: 10,
          searchviaboolean: true,
          booleanquery: "*",
          industries: [],
          locations: [],
          companysizes: [],
           companybuckettypes: [
              "Fortun500"
           ],
            companynames: pastindustries
        }
      
        this.companyinsightsservice.getRecommendedcompanies(recommendpayload).subscribe((res:any)=>{
          if(res.status == 'success') {
            const companysizes = _.uniq(_.pluck(res.data.results, 'size'))
            const industries = _.uniq(_.pluck(res.data.results, 'industry'))
            skills = _.uniq(_.pluck(skills, 'skill'));

            const totalTenure = this.parseresumeresp.candidatebasicinfo.totalexperience || 0;
            const fromYrsOfExperience = (parseInt(totalTenure) - (parseInt(totalTenure) * 0.25));
            const toYrsOfExperinece = (parseInt(totalTenure) + (parseInt(totalTenure) * 0.25));

            this.similarobj = {
              jobtitle: this.parseresumeresp.candidatebasicinfo && this.parseresumeresp.candidatebasicinfo.jobtitle ? [{ key: this.parseresumeresp.candidatebasicinfo.jobtitle, isMandatory: true }] : [],
              jobcompanyname: this.parseresumeresp.candidatebasicinfo && this.parseresumeresp.candidatebasicinfo.currentcompany ? [{ key: this.parseresumeresp.candidatebasicinfo.currentcompany, isMandatory: false }] : [],
              jobindustryname: industries.map(i => ({ key: i, isMandatory: false })),
              pastindustries: industries, 
              schools: _.pluck(this.parseresumeresp.education, 'schoolname'),
              currentlocation: _.uniq(locations).map(l => ({ key: l, isMandatory: false })),
              skills: skills.map(skill => ({ key: skill, isMandatory: false })),
              elasticid: null,
              companysize: companysizes.map(cs => ({ key: cs, isMandatory: false })),
              fullname: this.parseresumeresp.candidatebasicinfo.firstname + ' ' + this.parseresumeresp.candidatebasicinfo.lastname,
              linkedinurl: this.linkedinurl,
              isUploadedFromResume: true,
              locationregion: null,
              locationcontinent: null,
              totaltenure: totalTenure,
              fromYrsOfExperience,
              toYrsOfExperinece
            }
            this.disableSimilarBtn = false;
          }
        })
       

      }
     
    })
    }

    openSimilarCandidateFilters(type: string) {
      this.personsearchservice.passsimilarcandidatesdata( {data: this.similarobj, calledfrom: type });
      // const modalRef = this.modalService.open(SimilarCandidateFilterComponent, { size: 'xl', windowClass: 'modal-size',centered: true, backdrop: 'static', keyboard: false });
      // modalRef.result.then((res) => {
      //   if(res.action == 'submit') {
      //     this.personsearchservice.passsimilarcandidatesdata(res);
      //     this.modalService.dismissAll();
      //     this.localStorageService.setItem('similar-candidates-additional-filters', JSON.stringify(res));
      //     this.router.navigate(['/person/search/listing'], { queryParams: { type: res.calledfrom } });
      //   }
      // });
      this.router.navigate(['/person/search/listing'], { queryParams: { type: type } });

      const modalRef = this.modalService.open(
        AiModalScComponent, 
        { size: 'xl', windowClass: 'genAimodal',centered: true, backdrop: 'static', keyboard: false }
      );
      const modalInstance: AiModalScComponent = modalRef.componentInstance;
      modalInstance.similarCandidateData = { data: this.similarobj, calledfrom: type } as unknown as SCPassData;
      this.localStorageService.setItem('similar-candidates-additional-filters', JSON.stringify(this.similarobj));

      // const modalResult$ = from(modalRef.result);
      // modalResult$.subscribe((res: SCPassData) => {
      // });
    }

    resetFormFields() {
      this.uploadedFilename = null;
      this.disableSimilarBtn = true;
    }
}
